export default __webpack_public_path__ + "static/media/code.e863dffa.mp4";